import { computed, Injectable, signal } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { Stats, StatsGoodsReturnsStatus, StatsService } from '../../stats'

interface GoodsReturnsCountersState {
  warehouseId?: string
  status?: StatsGoodsReturnsStatus[]
  counters?: Stats['goodsReturns']
  isLoading: boolean
  error?: HttpErrorResponse
}

const COUNTERS_INITIAL_STATE: GoodsReturnsCountersState = {
  isLoading: false,
}

@Injectable()
export class GoodsReturnsCountersStore {
  constructor(private statsService: StatsService) {}

  private state = signal<GoodsReturnsCountersState>(COUNTERS_INITIAL_STATE)

  // Selectors

  readonly counters = computed(() => this.state().counters)
  readonly isLoading = computed(() => this.state().isLoading)

  /**
   * EFFECTS
   */
  async load(status?: StatsGoodsReturnsStatus[]): Promise<void> {
    this.unsetError()

    return new Promise((resolve, reject) => {
      this.statsService
        .stats$({
          goodsReturns: status || [
            'RETURNING',
            'RECEIVED',
            'CLOSED',
            'CANCELED',
          ],
        })
        .subscribe({
          next: (data) => {
            resolve()
            this.setData(data.goodsReturns)
          },
          error: (error) => {
            reject(error)
            this.setError(error)
          },
        })
    })
  }

  /**
   * REDUCERS
   */

  setIsLoading(isLoading: boolean) {
    this.state.set({ ...this.state(), isLoading })
  }

  setError(error: HttpErrorResponse) {
    this.state.set({ ...this.state(), isLoading: false, error })
  }

  unsetError() {
    this.state.set({ ...this.state(), isLoading: true, error: undefined })
  }

  setData(counters: {
    RETURNING?: number
    RECEIVED?: number
    CLOSED?: number
    CANCELED?: number
  }) {
    this.state.set({
      ...this.state(),
      counters,
      isLoading: false,
      error: undefined,
    })
  }
}
